import { useParams } from "react-router-dom";
import { Globe } from "lucide-react";

export default function Blocked() {
  const { code } = useParams();
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-neutral-50 p-4"
      data-testid="blocked-page"
    >
      <div className="w-full max-w-md rounded-2xl border border-neutral-200 bg-white p-8 text-center shadow-lg md:p-10">
        <div className="mb-6 flex justify-center">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-full border border-neutral-200 bg-neutral-100">
            <Globe size={22} strokeWidth={2.25} className="text-neutral-700" />
          </div>
        </div>
        <h1 className="text-xl font-semibold text-neutral-900 md:text-2xl">
          Not available in your region
        </h1>
        <p className="mt-2 text-sm text-neutral-500">
          This link isn’t available in your country. If you believe this is a mistake, please
          contact the person who shared it with you.
        </p>
        {code ? (
          <p className="mt-6 font-mono text-2xs uppercase tracking-[0.22em] text-neutral-400">
            /{code}
          </p>
        ) : null}
      </div>
    </div>
  );
}
